<template>
  <div classs="container-fluid">
    <div class="row justify-content-md-center">
      <div class="col-12 col-md-8 text-center mt-5 mb-5">
        <!-- eslint-disable-next-line prettier/prettier -->
        <img src="@/assets/image/logo.png" alt="ロゴ" style="width: 240px;" />
      </div>
      <div class="col-12 col-md-8 text-center">
        <div class="alert alert-warning pt-5 pb-5 mb-5">
          {{ errorMessageByStatusCode }}
        </div>
        <template>
          <div class="btn btn-link rounded-pill mt-4" @click="returnToLogin">
            {{ $t('ログイン画面に戻る') }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

const pageNotFound = '404 Not Found';
const otherError = 'An error occurred';

export default defineComponent({
  layout: 'errorPageLayout',
  props: {
    error: {
      type: Object,
      default: null
    }
  },
  computed: {
    errorMessageByStatusCode() {
      const statusCode = this.error.statusCode;
      if (statusCode === 404) {
        return `${statusCode}: ${this.$t('errorMessages.404')}`;
      } else if (statusCode === 1001) {
        return this.$t('errorMessages.1001');
      }

      return `${statusCode}: ${this.$t('errorMessages.common')}`;
    }
  },
  methods: {
    async returnToLogin() {
      const token = await this.$auth.getToken();
      if (token !== null) {
        this.$auth.logout();
        this.$router.push('/login');
      } else {
        this.$router.push('/');
      }
    }
  },
  head() {
    const title = this.error.statusCode === 404 ? pageNotFound : otherError;
    return {
      title
    };
  }
});
</script>
